import Finder from './Main.vue'

export default Finder
